<template>
  <span :class="couleur">
    <v-combobox
      :prepend-inner-icon="icone"
      style="background: transparent"
      class="inputSearch"
      v-model="valeur"
      :label="label"
      :color="couleur"
      variant="underlined"
      density="default"
      :item-text="texte"
      hide-no-data
      :items="elements"
      return-object
      :search-input.sync="saisie"
      @input="lanceRecherche"
      @blur="resetValeur"
      ref="cb"
    >
    </v-combobox>
  </span>
</template>

<script>
import denominationsService from "@/services/DenominationsService";
import fournisseursService from "@/services/FournisseursService";
import produitsService from "@/services/ProduitsService";

export default {
  name: "AppSearchField",
  props: {
    type: {
      type: String,
      default: "deno", // || "prod" || "frn"
    },
  },
  data() {
    return {
      valeur: null,
      elements: null,
      texte: "",
      saisie: "",
      fetcher: null,
      label: "",
      icone: "",
      couleur: "",
      leaving: false,
    };
  },
  watch: {
    saisie() {
      if (this.saisie && this.saisie.length >= 3) {
        this.fetcher(this.saisie)
          .then((response) => {
            this.elements = response.data;
          })
          .catch(() => {
            this.elements = null;
          });
      }
    },
  },
  methods: {
    resetValeur() {
      // console.log("->reset");
      this.leaving = true;
      this.saisie = null;
      this.valeur = null;
      this.leaving = false;
      return true;
    },
    lanceRecherche() {
      if (this.leaving) {
        // console.log("->leaving");
        return;
      }
      // console.log("lanceRecherche:", this.valeur);
      let recherche;
      let to = null;
      switch (this.type) {
        case "prod":
          recherche = this.valeur.denominationCommerciale || this.valeur;
          to = {
            name: "produits",
            query: { q: recherche },
          };
          break;
        case "deno":
          recherche = this.valeur.libelle || this.valeur;
          to = {
            name: "denos-communes",
            query: { q: recherche },
          };
          break;
        case "frn":
          recherche = this.valeur.nom || this.valeur;
          to = {
            name: "fournisseurs",
            query: { q: recherche },
          };
          break;
      }

      // Réinitialisation du champ après recherche
      this.leaving = true;
      this.elements = null;
      this.$refs["cb"].blur();

      // Redirection
      if (to != null) {
        this.$router.push(to);
      }
    },
  },
  created() {
    switch (this.type) {
      case "prod":
        this.fetcher = produitsService.getProduitsAutocomplete;
        this.icone = "mdi-medical-bag";
        this.couleur = "produit";
        this.label = "Produit";
        this.texte = "denominationCommerciale";
        break;
      case "frn":
        this.fetcher = fournisseursService.getFournisseursAutocomplete;
        this.icone = "mdi-tooltip-account";
        this.couleur = "fournisseur";
        this.label = "Fournisseur";
        this.texte = "nom";
        break;
      case "deno":
        this.fetcher = denominationsService.getDenominationsAutocomplete;
        this.icone = "mdi-ballot";
        this.couleur = "deno";
        this.label = "Dénomination";
        this.texte = "libelle";
        break;
    }
  },
};
</script>

<style>
.produit .theme--light.v-text-field .v-input__control .v-input__slot:before {
  border-color: #025e21;
}

.produit .theme--light.v-label,
.produit .theme--light.v-input:not(.v-input--is-disabled) input,
.produit .theme--light.v-input:not(.v-input--is-disabled) textarea,
.produit .theme--light.v-icon {
  color: #025e21;
}

.deno .theme--light.v-label,
.deno .theme--light.v-input:not(.v-input--is-disabled) input,
.deno .theme--light.v-input:not(.v-input--is-disabled) textarea,
.deno .theme--light.v-icon {
  color: #325a76;
}

.deno .theme--light.v-text-field .v-input__control .v-input__slot:before {
  border-color: #325a76;
}
.fournisseur .theme--light.v-label,
.fournisseur .theme--light.v-input:not(.v-input--is-disabled) input,
.fournisseur .theme--light.v-input:not(.v-input--is-disabled) textarea,
.fournisseur .theme--light.v-icon {
  color: #cd8d03;
}

.fournisseur
  .theme--light.v-text-field
  .v-input__control
  .v-input__slot:before {
  border-color: #cd8d03;
}
</style>
